import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import AssetSubtype, { newAssetSubtype } from "../../models/asset-subtype";
import AssetSubtypeForm from "./AssetSubtypeForm";

interface AssetSubtypeUpdateModalProps {
  show: boolean;
  assetSubtype?: AssetSubtype;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const AssetSubtypeUpdateModal: React.FC<AssetSubtypeUpdateModalProps> = ({
  show,
  assetSubtype,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialAssetSubtype, setInitialAssetSubtype] = useState<AssetSubtype>(
    assetSubtype ? assetSubtype : newAssetSubtype()
  );

  const modalTitle = assetSubtype
    ? `Editar Subtipo de productor: ${assetSubtype.name}`
    : `Crear Subtipo de productor nuevo`;

  const onClose = () => {
    setInitialErrors({});
    setInitialAssetSubtype(newAssetSubtype());
    onCancel();
  };
  useEffect(() => {
    setInitialAssetSubtype(assetSubtype ? assetSubtype : newAssetSubtype());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetSubtype]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <AssetSubtypeForm
            initialAssetSubtype={initialAssetSubtype}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default AssetSubtypeUpdateModal;
